export class ProblemDetail {
    constructor(title, detail) {
        this.title = title;
        this.detail = detail;
    }
}
